<script>
import {mapGetters} from "vuex";
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import Vue from 'vue'

import TasksMadeAndExpensesModal from "../components/TasksMadeAndExpensesModal";

export default {
  name:'CustomerService',
  components: {
    DatePicker,
    TasksMadeAndExpensesModal,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    })
  },
  data () {
    return {
      eventHub: new Vue(),
      customerServiceId: null,
      tasks: false,
      taskId: '',
      taskTypes: false,
      taskTypeId: '',
      customers: false,
      customerId: '',
      users: false,
      userId: '',
      note: '',
      errors: {},
      customerServices: [],
      filters: {},
      stringFilters: null,
      loadStringFilters: false,
      searchTimeout: null,
      date: new Date (),
      servicesStatus: null,
      isFixedValue: false,
      fixedValue: null,
      movidesk_ticket_id: null,
    };
  },
  mounted() {
    this.loadOptions();
    this.loadCustomerServices();
    this.loadFilters();
  },
  provide() {
    return {
      eventHub: this.eventHub
    }
  },
  methods: {
    loadOptions () {
      axios
        .get('/api/tasks')
        .then(({ data }) => this.tasks = data);

      axios
        .get('/api/task_types')
        .then(({ data }) => this.taskTypes = data.data);

      axios
        .get('/api/customers')
        .then(({ data }) => this.customers = data.data);

      axios
        .get('/api/users')
        .then(({ data }) => this.users = data.data);

      this.servicesStatus = [
        {
          id: 'pending',
          name: 'Pendente',
        },
        {
          id: 'in_progress',
          name: 'Em Andamento',
        },
        {
          id: 'completed',
          name: 'Finalizado',
        }
      ];
    },
    loadCustomerServices () {
      if (!this.loadStringFilters) {
        const today = new Date ();
        const startDate = new Date(today.setDate(today.getDate() - 30));
        this.stringFilters = `startDate=${this.formatDate(startDate)}&endDate=${this.formatDate(this.date)}`
      }
      axios
        .get(`/api/customer-service?${this.stringFilters}`)
        .then(({ data }) => this.customerServices = data.data);
    },
    initialValues () {
      this.taskId = '';
      this.taskTypeId = '';
      this.customerId = '';
      this.userId = '';
      this.note = '';
      this.errors = {};
      this.customerServiceId = null;
      this.isFixedValue = false;
      this.fixedValue = null;
      this.movidesk_ticket_id = null;
    },
    submit () {
      if (this.customerServiceId) {
        this.handleUpdate();
        return;
      }
      this.handleSubmit();
    },
    handleSubmit () {
      axios
        .post('/api/customer-service', {
          task_id: this.taskId,
          task_type_id: this.taskTypeId,
          customer_id: this.customerId,
          user_id: this.userId,
          note: this.note,
          is_fixed_value: this.isFixedValue,
          fixed_value: this.isFixedValue ? this.fixedValue : null,
          movidesk_ticket_id: this.movidesk_ticket_id,
        })
        .then(() => {
          this.initialValues();
          this.$toast.success("Registro cadastrado com sucesso!");
          this.loadCustomerServices();
        })
        .catch((err) => {
          this.errors = err.response.data.errors
          this.requestFail()
        });
    },
    edit (customerService) {
      this.taskId = customerService.task_id;
      this.taskTypeId = customerService.task_type_id;
      this.customerId = customerService.customer_id;
      this.userId = customerService.user_id;
      this.note = customerService.note;
      this.customerServiceId = customerService.id;
      this.isFixedValue = !!customerService.is_fixed_value;
      this.fixedValue = customerService.fixed_value;
      this.movidesk_ticket_id = customerService.movidesk_ticket_id;
    },
    handleUpdate () {
      axios
        .put(`/api/customer-service/${this.customerServiceId}`, {
          task_id: this.taskId,
          task_type_id: this.taskTypeId,
          customer_id: this.customerId,
          user_id: this.userId,
          note: this.note,
          is_fixed_value: this.isFixedValue,
          fixed_value: this.isFixedValue ? this.fixedValue : null,
          movidesk_ticket_id: this.movidesk_ticket_id,
        })
        .then(() => {
          this.$toast.success("Registro atualizado com sucesso!")
          this.initialValues();
          this.loadCustomerServices();
        })
        .catch((err) => {
          this.errors = err.response.data.errors
          this.requestFail()
        });
    },
    destroy (id) {
      this.$confirm({
        message: `Tem certeza que deseja excluir?`,
        button: {
          no: 'Não',
          yes: 'Sim'
        },
        callback: confirm => {
          if (confirm) {
            axios
              .delete(`/api/customer-service/${id}`)
              .then(() => {
                this.$toast.success("Registro excluido com sucesso!");
                this.loadCustomerServices();
              })
              .catch((err) => {
                this.errors = err.response.data.errors;
                this.loadCustomerServices();
                this.requestFail();
              });
          }
        }
      })
    },
    tasksMadeExpenses (customerService) {
      this.eventHub.$emit('tasks-made-expenses-modal', customerService)
    },
    reOpen (id) {
      this.$confirm({
        message: `Tem certeza que deseja reabir o Ticket?`,
        button: {
          no: 'Não',
          yes: 'Sim'
        },
        callback: confirm => {
          if (confirm) {
            axios
              .patch(`/api/customer-service/${id}/re-open`)
              .then(() => {
                this.$toast.success("Ticket re aberto com sucesso!");
                this.loadCustomerServices();
              })
              .catch((err) => {
                this.errors = err.response.data.errors;
                this.loadCustomerServices();
                this.requestFail();
              });
          }
        }
      })
    },
    requestFail () {
      let message = '';
      for (let i in this.errors) {
        message = `${this.errors[i]} <br /> ${message}`
      }
      this.$swal({
        title: 'Ops...',
        text: message,
        icon: 'error',
        html: message,
      })
    },
    renameStatus (status) {
      if (status === 'pending')
        return 'Pendente';
      if (status === 'in_progress')
        return 'Em Andamento';
      if (status === 'completed')
        return 'Finalizado';

      return "error";
    },
    formatDate (date) {
      return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2));
    },
    formatDateBr (originalDate) {
      const data = new Date(originalDate);
      return data.toLocaleDateString("pt-BR");
    },
    builderFilters () {
      let filters = {
        startDate: this.formatDate(this.filters.startDate),
        endDate: this.formatDate(this.filters.endDate)
      }

      if (this.filters.task)
        filters.task = this.filters.task

      if (this.filters.taskType)
        filters.taskType = this.filters.taskType

      if (this.filters.customer)
        filters.customer = this.filters.customer

      if (this.filters.note)
        filters.note = this.filters.note

      if (this.filters.user)
        filters.userId = this.filters.user

      if (this.filters.status)
        filters.status = this.filters.status

      this.builderFiltersString(filters)
    },
    builderFiltersString (filters) {
      let filterString = ''
      for (let filter in filters) {
        if (filters[filter] != null) {
          filterString += filter + '=' + filters[filter] + '&'
        }
      }
      this.stringFilters = filterString.substring(0, filterString.length - 1)
      this.loadStringFilters = true;
      this.loadCustomerServices();
    },
    clearFilters () {
      this.stringFilters = ''
      this.loadFilters()
      this.loadStringFilters = false
      this.loadCustomerServices()
    },
    search () {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.builderFilters()
      }, 1000)
    },
    loadFilters () {
      this.filters = {
        startDate: new Date (),
        endDate: new Date (),
        task: '',
        taskType: '',
        customer: '',
        note: ''
      }
    },
    secondsToHours (seconds) {
      if (isNaN(seconds)) {
        return '00:00:00';
      }

      const hours = Math.trunc(seconds / 3600);
      seconds %= 3600;

      const minutes = Math.trunc(seconds / 60);
      seconds %= 60;

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
  },
  watch: {
    taskTypeId (val) {
      if (val && this.taskTypes) {
        const type = this.taskTypes.find(t => t.id === val)
        this.isFixedValue = type ? !!type.is_fixed_value : false
      } else {
        this.isFixedValue = false
      }
    }
  }
}
</script>

<template>
  <main>
    <tasks-made-and-expenses-modal />
    <div v-show="customerServiceId" class="w-100 text-center bg-danger p-2 text-white">Editando Ticket</div>
    <form v-on:submit.prevent="submit" class="row task-made-form">
      <div class="row">
        <div class="form-group col-md-2 input-form">
          <v-select
            :reduce="item => item.id"
            placeholder="Consultor"
            label="name"
            v-model="userId"
            :options="users"
            v-if="users"/>
        </div>

        <div class="form-group col-md-2 input-form">
          <v-select
            :reduce="item => item.id"
            placeholder="Cliente"
            label="name"
            v-model="customerId"
            :options="customers"
            v-if="customers"/>
        </div>

        <div class="form-group col-md-2 input-form">
          <v-select
            :reduce="item => item.id"
            placeholder="Atividade"
            label="name"
            v-model="taskId"
            :options="tasks"
            v-if="tasks"/>
        </div>

        <div class="form-group col-md-2 input-form">
          <v-select
            :reduce="item => item.id"
            placeholder="Classificação"
            label="name"
            v-model="taskTypeId"
            :options="taskTypes"
            v-if="taskTypes"/>
        </div>

        <div class="form-group col-md-2 input-form">
          <input
            class="form-control"
            type="text"
            v-model="note"
            placeholder="Observação"
            name="note"
            id="note">
        </div>
        <div class="form-group col-md-1 input-form">
          <input
            class="form-control"
            type="number"
            v-model="movidesk_ticket_id"
            placeholder="Ticket Movidesk"
            name="movidesk_ticket_id"
            id="movidesk_ticket_id">
        </div>


        <div class="form-group col-md-1 input-form" v-if="isFixedValue">
          <input
            class="form-control"
            type="number"
            step="0.01"
            v-model="fixedValue"
            placeholder="Valor"
            name="fixed_value"
            id="fixed_value">
        </div>

        <div class="col-auto align-content-end d-flex flex-row gap-1">
          <button type="submit" class="btn btn-outline-success">Salvar</button>
          <button type="button" class="btn btn-outline-secondary" @click="initialValues">cancelar</button>
        </div>
      </div>
    </form>

    <div class="accordion mt-3" id="accordionFilters">
      <div class="accordion-item">
        <h5 class="accordion-header" id="headingOne">
          <button class="accordion-button collapsed"
            :style="'color:' + (loadStringFilters ? 'red' : 'blue')"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="false"
            aria-controls="collapseOne"
          >
            {{ loadStringFilters ? 'Filtros ativos' : 'Filtros' }}
          </button>
        </h5>

        <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionFilters">
          <div class="accordion-body">
            <div class="d-flex flex-column">
              <div class="d-flex flex-wrap gap-1">
                <div class="input-form">
                  <date-picker
                    v-model ="filters.startDate"
                    format="DD/MM/YY"
                    v-mask="'##/##/##'"
                  >
                  </date-picker>
                </div>
                <div class="input-form">
                  <date-picker
                    v-model ="filters.endDate"
                    format="DD/MM/YY"
                    v-mask="'##/##/##'"
                  >
                  </date-picker>
                </div>

                <div class="input-form col-sm-3">
                  <v-select
                    :reduce="item => item.id"
                    placeholder="Consultor"
                    label="name"
                    v-model="filters.user"
                    :options="users"
                    v-if="users"
                  />
                </div>

                <div class="input-form col-sm-3">
                  <v-select
                    :reduce="customer => customer.id"
                    placeholder="Cliente"
                    label="name"
                    v-model="filters.customer"
                    :options="customers"
                    v-if="customers"
                  />
                </div>

                <div class="input-form flex-grow-1">
                  <v-select
                    :reduce="task =>task.id"
                    placeholder="Atividade"
                    label="name"
                    v-model="filters.task"
                    :options="tasks"
                    v-if="tasks"
                  />
                </div>


              </div>
              <div class="d-flex flex-row gap-1 mt-2">
                <div class="input-form col-sm-3">
                  <v-select
                    :reduce="taskType => taskType.id"
                    placeholder="Classificação"
                    label="name"
                    v-model="filters.taskType"
                    :options="taskTypes"
                    v-if="taskTypes"
                  />
                </div>
                <div class="input-form col-sm-3">
                  <v-select
                    :reduce="status => status.id"
                    placeholder="Status"
                    label="name"
                    v-model="filters.status"
                    :options="servicesStatus"
                    v-if="servicesStatus"
                  />
                </div>
                <div class="input-form flex-grow-1">
                  <input
                    class="form-control"
                    type="text"
                    v-model="filters.note"
                    placeholder="Observação"
                    name="note"
                  >
                </div>

                <div class="d-flex gap-1">
                  <div class="input-form">
                    <button
                      v-on:click="builderFilters"
                      class="btn btn-warning"
                    >
                      Buscar
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                  <div class="input-form">
                    <button
                      v-on:click="clearFilters"
                      class="btn btn-danger"
                    >
                      Limpar
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="mt-4">
      <div class="card card-body table-responsive">
        <table class="table table-striped tasks-table">
          <thead>
          <tr>
            <th>Data</th>
            <th>Consultor</th>
            <th>Cliente</th>
            <th>Atividade</th>
            <th>Tipo de Trabalho</th>
            <th>Fixo</th>
            <th>Valor</th>
            <th>Observação</th>
            <th>Ticket Movidesk</th>
            <th>Status</th>
            <th width="120px">Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="customerService in customerServices" :key="customerService.id">
            <td>{{formatDateBr(customerService.created_at)}}</td>
            <td>{{customerService.user_name}}</td>
            <td>{{customerService.customer_name}}</td>
            <td>{{customerService.task_name}}</td>
            <td>{{customerService.task_type_name}}</td>
            <td>{{ customerService.is_fixed_value ? 'Sim' : 'Não' }}</td>
            <td>{{ customerService.is_fixed_value ? 'R$ ' + customerService.fixed_value : '-' }}</td>
            <td class="tasks-td-large" :title="customerService.note">{{ customerService.note }}</td>
            <td>{{ customerService.movidesk_ticket_id || '-' }}</td>
            <td>{{renameStatus(customerService.status)}}</td>
            <td class="d-flex justify-content-end">
              <button
                v-if="customerService.status == 'completed' && !customerService.invoiced"
                title="re abrir"
                class="btn btn-outline-primary btn-sm mb-1 text-center"
                type="button"
                @click="reOpen(customerService.id)"
              >
                <i class="fa fa-reply" />
              </button>
              <button
                v-if="customerService.status !== 'pending'"
                title="Ver Atividades"
                class="btn btn-outline-success btn-sm mb-1 text-center"
                type="button"
                @click="tasksMadeExpenses(customerService)"
              >
                <i class="fa fa-eye" />
              </button>
              <button
                v-if="customerService.status == 'pending'"
                title="Editar"
                type="button"
                class="btn btn-outline-primary btn-sm mb-1"
                v-on:click="edit(customerService)"
              >
                <i class="fas fa-edit" />
              </button>
              <button
                v-if="customerService.status == 'pending'"
                title="Excluir"
                type="button"
                class="btn btn-outline-danger btn-sm mb-1"
                v-on:click="destroy(customerService.id)"
              >
                <i class="fa fa-trash" />
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </main>
</template>

<style scoped lang="sass">
.task-made-form
  margin-top: 10px
.input-form
  padding-right: 0

.time-form
  display: inline-block
  width: auto
  padding-left: 0

  input
    margin-left: 10px
    display: inline-block
    width: 60px
.tasks-table
  font-size: small
  td
    button
      margin-right: 3px
  tr
    max-height: 10px
  input
    font-size: small

.tasks-td-small
  min-width: 40px
  max-width: 60px
  white-space: nowrap

.tasks-td-medium
  min-width: 80px
  max-width: 110px
  white-space: nowrap

.tasks-td-large
  min-width: 200px
  max-width: 250px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

</style>
